export default __webpack_public_path__ + "static/media/Risques pour la protection du patrimoine naturel.e7d25053.svg";